import * as Yup from 'yup'
const schema = Yup.object().shape({
    stakeholder: Yup.object().nullable().required('Required'),
    company:Yup.array().of(Yup.object()).nullable().required('Required').min(1,'Required')
})
export default schema